/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VoucherProrogaEsitoDTO { 
    /**
     * Voucher la cui scadenza e\' stata spostata
     */
    prorogati?: number;
    /**
     * Voucher prorogabili per stato ma lasciati invariati (gia\' oltre la data, o senza scadenza con forma GIORNI)
     */
    saltati?: number;
    /**
     * Id del lotto registrato (storico della proroga di bando)
     */
    lotto_id?: string;
}

